<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      Sanksi Anggota
      <!-- <CButton color="info" class="btn-md ml-auto">Ekspor Excel</CButton> -->
      <template v-if="role_status && role_status.status_create">
      <CButton color="success" class="btn-md ml-auto" @click="sanksiForm">Tambah</CButton>
      </template>
    </CCardHeader>
    <!-- Data BPK -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              v-model.number="pageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">            
            <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht: 100% !important"
            :items="items"
            :fields="fields"
            hover
            sorter
          >
            <template #no="{ index }">
              <td class="py-2">{{indexed == 0 ? index + 1 : index + indexed + 1}}</td>
            </template>
            <template #nomor_sanksi="{ item }">
              <td class="py-2 text-left font-weight-bold">
                {{ item.nomor_sanksi ? item.nomor_sanksi : "-" }}
              </td>
            </template>
            <template #nama_lengkap="{ item }">
              <td class="py-2 text-left">
                {{ item.nama_lengkap ? item.nama_lengkap : "-" }}
              </td>
            </template>
            <template #nama_kategori="{ item }">
              <td class="py-2 text-left">
                {{ item.nama_kategori ? item.nama_kategori : "-" }}
              </td>
            </template>
            <template #sanksi="{ item }">
              <td class="py-2 text-left">
                {{ item.sanksi ? item.sanksi : "-" }}
              </td>
            </template>
            <template #pemberi_sanksi="{ item }">
              <td class="py-2 text-left text-uppercase">
                {{ item.pemberi_sanksi ? item.pemberi_sanksi : "-" }}
              </td>
            </template>
            <template #no_anggota="{ item }">
              <td class="py-2 text-left font-weight-bold">
                {{ item.no_anggota ? item.no_anggota : "-" }}
              </td>
            </template>
            <template #tanggal_mulai="{ item }">
              <td class="py-2 text-left">
                {{ item.tanggal_mulai ? item.tanggal_mulai : "-" }}
              </td>
            </template>
            <template #sanksi_berakhir="{ item }">
              <td class="py-2 text-left">
                {{ item.sanksi_berakhir ? item.sanksi_berakhir : "-" }}
              </td>
            </template>
            <template #keterangan="{ item }">
              <td class="py-2 text-left">
                {{ item.keterangan.substr(0,250) + '...' ? item.keterangan.substr(0,250) + '...' : "-" }}
              </td>
            </template>
            <template #aksi="{ item, index }">
              <td class="py-2 text-left">
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float: right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
       <!-- Modal Sanksi -->
      <CModal
        title="Modal title"
        :show.sync="myModalsanksi"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postSanksi">
          <CRow>
            <div class="modal-body py-0" id="formidentify">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">Pemberi Sanksi</label>
                    <select name="" class="form-control" id="" v-model="formSanksi.pemberiSanksi">
                      <option value="iapi">IAPI</option>
                      <option value="regulator">Regulator</option>
                    </select>
                  </div>
                  <div class="form-group col-md-12" v-if="formSanksi.pemberiSanksi == 'regulator'">
                    <label class="font-weight-bold">Tipe Regulator</label>
                    <select name="" class="form-control" id="" v-model="formSanksi.tipeRegulator">
                      <option value="BPK">BPK</option>
                      <option value="OJK">OJK</option>
                      <option value="PPPK">PPPK</option>
                    </select>
                  </div>                 
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">Nomor Sanksi</label>
                    <input
                      type="number"
                      class="form-control"
                      min="0"
                      id="nomor_sanksi"
                      placeholder="Nomor Sanksi"
                      v-model="formSanksi.nomorSanksi"
                      :class="{
                        'border-danger': $v.formSanksi.nomorSanksi.$error
                      }"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label class="font-weight-bold">Peserta</label>
                    <multiselect
                      class="multi-select"
                      placeholder="Pilih Peserta"
                      id="peserta"
                      :custom-label="customLabel"
                      required
                      @select="changeAnggota"
                      :options="dataAnggota"
                      v-model="idUser"
                      :class="{
                        'border-danger': $v.formSanksi.idUser.$error
                      }">
                      <template slot="option"  slot-scope="{ option }">{{ option.no_anggota ? option.no_anggota + ' - ' : '' }} {{ option.nama_lengkap ?  option.nama_lengkap : 'IAPI'}}</template>
                    </multiselect>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="sanksi" class="font-weight-bold">Sanksi</label>
                    <input
                      type="text"
                      class="form-control"
                      id="sanksi"
                      placeholder="Masukkan nama sanksi"
                      min="0"
                      v-model="formSanksi.sanksi"
                      :class="{
                        'border-danger': $v.formSanksi.sanksi.$error
                      }"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label for="sanksi" class="font-weight-bold">Keterangan Sanksi</label>
                     <textarea
                      type="text"
                      class="form-control"
                      id="sanksi"
                      rows="5"
                      placeholder="Masukkan Keterangan Sanksi"
                      v-model="formSanksi.keterangan"
                      :class="{
                        'border-danger': $v.formSanksi.keterangan.$error
                      }"
                     />            
                  </div>
                  <div class="form-group col-md-6">
                      <label for="tgl_mulai" class="font-weight-bold">Tanggal Mulai</label>
                      <input
                        type="date"                      
                        class="form-control"
                        required
                        id="tgl_mulai"
                        placeholder="Masukkan Tanggal"
                        v-model="formSanksi.tanggalMulai"
                        :min="today"
                        :class="{
                          'is-invalid': $v.formSanksi.tanggalMulai.$error,                     
                        }"
                      />                    
                  </div>
                  <div class="form-group col-md-6">
                    <label for="tgl_exp" class="font-weight-bold">Tanggal Berakhir</label>
                    <input
                      type="date"                      
                      class="form-control"
                      id="tgl_exp"
                      required
                      placeholder="Masukkan Tanggal"
                      v-model="formSanksi.tanggalBerakhir"
                      @click="triggerValidationExpired"
                      :min="today"
                      :class="{
                        'is-invalid': $v.formSanksi.tanggalBerakhir.$error,
                      }"
                    />
                    <span class="text-danger" v-if="$v.formSanksi.tanggalBerakhir.$error">
                      *Kurang dari tanggal mulai
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Tambah Sanksi</h6>
        </template>
        <template #footer>
          <CButton @click="myModalsanksi = false" color="danger">Tutup</CButton>
          <CButton @click="postSanksi" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
    </CCardBody>
    <!-- End Data BPK -->
  </CCard>
</template>
<script>
import SanksiService from "@/services/keanggotaan/sanksi/sanksi.service";
import DataKeanggotaanService from "@/services/keanggotaan/data-anggota.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import { required } from 'vuelidate/lib/validators';

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
  },
  {
    key: "nomor_sanksi",
    label: "Nomor Sanksi",
    sorter: true,
    filter: false,
  },
  {
    key: "no_anggota",
    label: "Nomor Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_lengkap",
    label: "Nama Lengkap",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_kategori",
    label: "Kategori Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "sanksi",
    label: "Sanksi",
    sorter: true,
    filter: false,
  },
  {
    key: "pemberi_sanksi",
    label: "Pemberi Sanksi",
    sorter: true,
    filter: false,
  },
  {
    key: "keterangan",
    label: "Keterangan",
    sorter: true,
    filter: false,
  },
  {
    key: "tanggal_mulai",
    label: "Tanggal Mulai",
    sorter: false,
    filter: false,
  },
  {
    key: "tanggal_berakhir",
    label: "Tanggal Berakhir",
    sorter: false,
    filter: false,
  },
  {
    key: "aksi",
    _style: "width:10%;",
    sorter: false,
    filter: false,
  }
];

export default {
  name: 'Sanksi',
  mixins: [AlertUtils, Pagination],

  data() {
    return {
      items: [],
      dataAnggota: [],
      idUser: '',
      title: '',     
      formSanksi: {
        idUser: '',
        nama_lengkap: '',
        namaKategori: "",
        keterangan: '',
        nomorSanksi: '',
        sanksi: '',
        pemberiSanksi: 'iapi',
        tipeRegulator: 'BPK',
        tanggalMulai: new Date().toISOString().slice(0, 10),
        tanggalBerakhir: new Date().toISOString().slice(0, 10),
      },
      pagination: {
        totalPages: 0,
      },
      currentPage: 0,
      fields,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      myModalsanksi: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      role_status: null
    };
  },

  validations: {
    formSanksi: {                  
      idUser: { required },
      nomorSanksi: { required },
      sanksi: { required },
      keterangan: { required },
      tanggalMulai: { required },
      tanggalBerakhir: { 
        required,
        isAfterDate(val, { tanggalMulai }) {
          return new Date(val) >= new Date(tanggalMulai);
        }
      },
    },
  },

  watch: {
    myModal: function() {
      if(!this.myModal) {
        this.clearValidation();
      }
    }
  },

  mounted() {
    this.roleData();
    this.getData("0", this.pageSize, "default");
    this.getDataPeserta();
    this.today = moment().format("YYYY-MM-DD")
  },

  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
        this.role_status = data;
      },
    customLabel ({ no_anggota, nama_lengkap, }) {
      return `${no_anggota} - ${nama_lengkap}`
    },

    triggerValidationExpired() {
      this.$v.formSanksi.tanggalBerakhir.$touch();
    },

    clearValidation() {
      this.$v.$reset()
      document.getElementById('nomor_sanksi').classList.remove('is-valid');
      document.getElementById('peserta').classList.remove('is-valid');
      document.getElementById('sanksi').classList.remove('is-valid');
      document.getElementById('keterangan').classList.remove('is-valid');
      document.getElementById('tlg_sanksi').classList.remove('is-valid');
    },
     pageChange() {
      this.getData(
        this.currentPage,
        this.pageSize,
        this.search,
      );
    },
    // ===== GET DATA ===== //
    getData(currentPage, pageSize, filter) {
      if (filter == "") {
        filter = "default";
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      SanksiService.getSanksi(currentPage, pageSize, filter)
        .then((response) => {
          loader.hide();
          // comment console console.log(response.data);
          // comment console console.log(response.data.data.content);
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
        });
    },
    // ===== GET DATA ===== //

    deleteData(item, index) {
      var vm = this;
      this.formData = item;

      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            SanksiService.deleteDataSanksi(this.formData)
              .then((response) => {
                // comment console console.log(response);
                this.getData("0", this.pageSize, "default", "default");
                vm.alertDeleteSuccess();

              })
              .catch((error) => {
                vm.alertErrorUser();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            vm.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    sanksiForm() {
      this.myModalsanksi = true;
      this.formSanksi [
        {
          idUser: '',
          nama_lengkap: '',
          namaKategori: "",
          keterangan: '',
          nomorSanksi: '',
          sanksi: '',
          pemberiSanksi: 'iapi',
          tipeRegulator: 'BPK',
          tanggalMulai: new Date().toISOString().slice(0, 10),
          tanggalBerakhir: new Date().toISOString().slice(0, 10),
        }
      ];
      this.actionPost = "insert";
      this.title = "Sanksi";
    },

    postSanksi() {
       this.$v.$touch();
      if(this.$v.formSanksi.idUser.$error) {
        var container = this.$el.querySelector("#formidentify");
        container.scrollIntoView()
        return false
      }     
      if(this.$v.formSanksi.nomorSanksi.$error) {
        var container = this.$el.querySelector("#formidentify");
        container.scrollIntoView()
        return false
      }     
      if(this.$v.formSanksi.sanksi.$error) {
        var container = this.$el.querySelector("#formidentify");
        container.scrollIntoView()
        return false
      }
      if(this.$v.formSanksi.keterangan.$error) {
        var container = this.$el.querySelector("#formidentify");
        container.scrollIntoView()
        return false
      }
      if(this.$v.formSanksi.tanggalMulai.$error) {
        var container = this.$el.querySelector("#formidentify");
        container.scrollIntoView()
        return false
      }
      if(this.$v.formSanksi.tanggalBerakhir.$error) {
        var container = this.$el.querySelector("#formidentify");
        container.scrollIntoView()
        return false
      }

      if(this.$v.formSanksi.$invalid) {
        return;
      } else {
        this.insertDataSanksi(this.formSanksi);
      }      
    },

    insertDataSanksi(formSanksi) {      
      var vm = this;
      SanksiService.postDataSanksi(formSanksi)
        .then((response) => {
          vm.myModalsanksi = false;
          this.getData("0", this.pageSize, this.search)
          vm.alertSuccess();
          vm.clearValidation();
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getDataPeserta() {
      var vm = this;
      DataKeanggotaanService.getAllDataAnggota()
        .then(response => {
          vm.dataAnggota = response.data.data;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    changeAnggota(value) {
      this.formSanksi.idUser = value.id_user;
    }
  },
  
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>